module.exports = __webpack_public_path__ + "img/serviceicon4.bc8b3992.gif";